/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import { useLocation, useNavigate } from "react-router-dom";
import BaseURL from "../../BaseURL/BaseURL";
import axios from "axios";
import Swal from "sweetalert2";
import { GoogleMap, useJsApiLoader, MarkerF } from "@react-google-maps/api";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { TailSpin } from "react-loader-spinner";
import Table from "react-bootstrap/Table";
import { FaStar } from "react-icons/fa";
import { BiShieldPlus } from "react-icons/bi";
import { FaCalendarAlt } from "react-icons/fa";
import { Form } from "react-bootstrap";
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

const containerStyle = {
  width: "100%",
  height: "500px",
};

const center = {
  lat: 24.8607343,
  lng: 67.0011364,
};

const Detail = () => {
  const search = useLocation().search;
  const id = new URLSearchParams(search).get("id");
  const user_id = localStorage.getItem("id");
  const token = localStorage.getItem("token");
  console.log(id, "id==== ");

  const [Loader, setLoader] = useState(false);
  const [api, setApi] = useState([]);
  const [Position, setPosition] = useState({
    lat: 0,
    lng: 0,
  });
  const [modal, setModal] = useState(false);
  const [reviewmodal, setReviewModal] = useState(false);
  const [queries, setQueries] = useState("");
  const [Subject, setSubject] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [Review, setReview] = useState("");
  const [Comment, setComment] = useState("");
  const [Reviewapi, setReviewapi] = useState([]);
  const [Catgory, setCatgory] = useState([]);

  const alldoctor = () => {
    // setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/doctor/${id}`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setApi(response?.data?.doctor);
          setReviewapi(response?.data?.doctor?.reviews);
          setPosition({
            lat: parseFloat(response.data.doctor?.lat),
            lng: parseFloat(response.data.doctor?.lng),
          });

          // dispatch(doctorapi(response.data.data))
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };
  const allcategory = () => {
    // setLoader(true);
    try {
      var config = {
        method: "Get",
        url: `${BaseURL.baseurl}/category`,
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          setCatgory(response?.data?.data);

        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  useEffect(() => {
    alldoctor();
    allcategory();
  }, []);
  const { isLoaded } = useJsApiLoader({
    // id: "google-map-script",
    googleMapsApiKey: "AIzaSyDF1PVJNBK1GGAQmfCpc-yepBkGUdkfgVQ",
    libraries: ["places"],
  });

  const handleClose = () => setModal(false);
  const handleReviewModalClose = () => setReviewModal(false);
  const handleReviewModalShow = () => {
    if (token) {
      setReviewModal(true);
    } else {
      navigate("/login");
    }
  };
  const navigate = useNavigate();

  const contact = () => {
    setLoader(true);

    const data = new FormData();
    data.append("name", name);
    data.append("email", email);
    data.append("subject", Subject);
    data.append("queries", queries);
    data.append("doctor_id", id);

    try {
      var config = {
        method: "POST",
        url: `${BaseURL.baseurl}/doctor/contact`,
        data: data,
        headers: {
          Accept: "application/json",
          // Authorization: `Bearer ${token}`,
        },
      };

      axios(config)
        .then(function (response) {
          setLoader(false);
          console.log(response, "api");
          setApi(response.data.data);
          if (response.data.status === true) {
            Swal.fire({
              title: response.data.response,
              text: "Email Sent Successfully",
              icon: "success",
              dangerMode: true,
            });
            handleClose();
          } else {
            Swal.fire({
              title: "Something Went Wrong",
              text: "check your Details",
              icon: "error",
              dangerMode: true,
            });
          }
        })
        .catch((errors) => {
          setLoader(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.errors ? errors.errors[0] : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  const review = () => {
    setLoader(true);
    try {
      const data = new FormData();
      data.append("doctor_id", id);
      data.append("star", Review);
      data.append("comment", Comment);

      var config = {
        method: "POST",
        url: `${BaseURL.baseurl}/doctor-review`,
        data: data,
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      axios(config)
        .then(function (response) {
          console.log(response, "api");
          if (response?.data?.status === true) {
            setLoader(false);
            handleReviewModalClose(false);
            Swal.fire({
              title: "Something Went Wrong",
              text: response?.data?.response
                ? response?.data?.response
                : "Review Submit",

              icon: "success",
              dangerMode: true,
            });
          } else {
            setLoader(false);
            console.log(response, "api");
          }
        })
        .catch((errors) => {
          console.log(errors, "api");
          setLoader(false);
          setModal(false);
          Swal.fire({
            title: "Something Went Wrong",
            text: errors.response?.data?.message
              ? errors.response?.data?.message
              : "check your Details",
            icon: "error",
            dangerMode: true,
          });
        });
    } catch (errors) {
      console.log(errors, "api");
      setLoader(false);
      console.log(errors, "error");
      Swal.fire({
        title: "Something Went Wrong",
        text: errors.errors ? errors.errors[0] : "check your Details",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  // const getreview = () => {
  //   // setLoader(true);
  //   try {
  //     var config = {
  //       method: "Get",
  //       url: `${BaseURL.baseurl}/api/reviews`,
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     };

  //     axios(config)
  //       .then(function (response) {
  //         console.log(response, "reviews");
  //         setReviewapi(response?.data?.data);
  //         // dispatch(doctorapi(response.data.data))
  //       })
  //       .catch((errors) => {
  //         setLoader(false);
  //         Swal.fire({
  //           title: "Something Went Wrong",
  //           text: errors.errors ? errors.errors[0] : "check your Details",
  //           icon: "error",
  //           dangerMode: true,
  //         });
  //       });
  //   } catch (errors) {
  //     setLoader(false);
  //     console.log(errors, "error");
  //     Swal.fire({
  //       title: "Something Went Wrong",
  //       text: errors.errors ? errors.errors[0] : "check your Details",
  //       icon: "error",
  //       dangerMode: true,
  //     });
  //   }
  // };

  // useEffect(() => {
  //   getreview();
  // }, []);



  return (
    <>
      <Header />
      <div class="container margin_60">
        <div className="profile border-right ">
          <div className="row">
            <div className="col-md-3 d-flex justify-content-center align-items-center flex-column">
              <h1 className="fw-bolder">
                {api?.name} {api?.last_name}
              </h1>
              <h6>
                Dentist
              </h6>
              <medium>
                {api?.address} | {api?.state}
              </medium>
            </div>
            <div className="col-md-3 border-right d-flex justify-content-center align-items-center flex-column">
              <div className="d-flex justify-content-center ">
                <FaStar className="fs-3 me-2" style={{ color: "#f52a3e" }} />
                <h4>Overall Rating</h4>
              </div>
              <h1 className="text-center">{api?.avg_review}</h1>
              <h6 className="text-center"><a href="#" >1 verified reviews</a></h6>
            </div>
            <div className="col-md-3 border-right d-flex justify-content-center align-items-center flex-column">
              <div className="d-flex justify-content-center ">
                <BiShieldPlus className="fs-3 me-2" style={{ color: "#f52a3e" }} />
                <h4 className="text-center">In-network with</h4>
              </div>
              <h6 className="text-center">Delta Dental Metlife</h6>
              <h6 className="text-center"><a href="#" >See, if they are in network</a></h6>
            </div>
            <div className="col-md-3 d-flex justify-content-center align-items-center flex-column">
              <div className="d-flex justify-content-start align-items-start mb-2">
                <FaCalendarAlt className="fs-3 me-2 ps-0" style={{ color: "#f52a3e" }} />
                <h6 className="">New Patient Appointment</h6>
              </div>
              <h6 className="">Appointment available for new patients on Dentective</h6>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-xl-12 col-lg-12">
            <div id="section_1">
              <div class="box_general_3">
                <div class="wrapper_indent">
                  <div className="row">
                    <div className="col-md-4 appointment">
                      <h1>Book an appointment for free</h1>
                      <h6>The office partners with Zocdoc to schedule appointments</h6>
                      <Form.Select aria-label="Default select example" className="my-4">
                        <option>Open this select menu</option>
                        {Catgory?.map((e)=>(
                          <option value={e?.id}>{e?.category}</option>
                        ))}
                      </Form.Select>
                      <h6> {api?.address} | {api?.city} | {api?.state} |{" "}
                        {api?.country}{" "}</h6>
                      <Form.Check // prettier-ignore
                        type="checkbox"
                        label="I'm a new Patient"
                      />
                    </div>
                    <div className="col-md-8">
                      <FullCalendar
                        plugins={[dayGridPlugin]}
                        initialView="dayGridMonth"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />

      <Modal
        show={modal}
        size="lg"
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center"
          >
            Contect Dentist
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="review">
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <input
                    type="text"
                    id="email_contact"
                    name="email_contact"
                    class="form-control"
                    placeholder="Name"
                    onChange={(e) => setName(e.target.value)}
                  />
                </div>
              </div>
              <div class="col-md-6 col-sm-12">
                <div class="form-group">
                  <input
                    type="email"
                    id="email_contact"
                    name="email_contact"
                    class="form-control"
                    placeholder="email"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-sm-12">
                <div class="form-group">
                  <input
                    type="text"
                    id="email_contact"
                    name="email_contact"
                    class="form-control"
                    placeholder="Subject"
                    onChange={(e) => setSubject(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div class="supaview__copy">
              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                onChange={(e) => setQueries(e.target.value)}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button class=" btn-theme" onClick={contact}>
            {Loader === true ? (
              <TailSpin
                height="20"
                width="20"
                color="#4fa94d"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            ) : (
              "Submit Query"
            )}
          </button>
          <Button onClick={handleClose} className="btn-theme">
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={reviewmodal}
        size="lg"
        onHide={handleReviewModalClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center"
          >
            Leave A Review
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form id="review">
            <fieldset class="supaview__rating">
              <input
                type="radio"
                id="star5"
                name="rate"
                value="5"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star5"></label>
              <input
                type="radio"
                id="star4"
                name="rate"
                value="4"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star4"></label>
              <input
                type="radio"
                id="star3"
                name="rate"
                value="3"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star3"></label>
              <input
                type="radio"
                id="star2"
                name="rate"
                value="2"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star2"></label>
              <input
                type="radio"
                id="star1"
                name="rate"
                value="1"
                onChange={(e) => setReview(e.target.value)}
              />
              <label for="star1"></label>
            </fieldset>
            <div class="supaview__copy">
              <textarea
                name="message"
                placeholder="Message"
                rows="5"
                onChange={(e) => setComment(e.target.value)}
              ></textarea>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button class=" btn-theme" onClick={review}>
            {Loader === true ? (
              <TailSpin
                height="20"
                width="20"
                color="#4fa94d"
                ariaLabel="tail-spin-loading"
                radius="1"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              />
            ) : (
              "Submit review"
            )}
          </button>
          <Button onClick={handleReviewModalClose} className="btn-theme">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Detail;
